import _get from 'lodash/get';

export const getChangedPropertiesByKeys = ({
  data,
  keys,
}: {
  data: any;
  keys: any;
}) => {
  return keys.reduce((properties: any, propertyKey: any) => {
    properties[propertyKey] = _get(data, propertyKey);

    return properties;
  }, {});
};
